import { render, staticRenderFns } from "./DesperatesellerLogo.vue?vue&type=template&id=dadd7194&scoped=true"
import script from "./DesperatesellerLogo.vue?vue&type=script&lang=js"
export * from "./DesperatesellerLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dadd7194",
  null
  
)

export default component.exports